module.exports = __webpack_public_path__ + "img/info_m.f06517b7.png";